import { render, staticRenderFns } from "./historique-traitement.html?vue&type=template&id=252e42cc&scoped=true&external"
import script from "./historique-traitement.js?vue&type=script&lang=js&external"
export * from "./historique-traitement.js?vue&type=script&lang=js&external"
import style0 from "./historique-traitement.scss?vue&type=style&index=0&id=252e42cc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252e42cc",
  null
  
)

export default component.exports